import { BoxProps } from 'grommet';
import { Right } from 'lib/api';
import { RightInfoCard } from './RightInfoCard';
import { RightInfoItem } from './RightInfoItem';
import { RightInfoRow } from './RightInfoRow';

export type ContactInformationProps = {
  background?: BoxProps['background'];
  right: Partial<Right>;
};

export const ContactInformation = ({ background, right }: ContactInformationProps) => {
  return (
    <RightInfoCard title="Contact Information" background={background}>
      <RightInfoRow>
        <RightInfoItem title="Licensor" value={right.licensor || 'Not specified'} />
        <RightInfoItem title="Licensee" value={right.licensee || 'Not specified'} />
        <RightInfoItem title="Rights Admin" value={right.rightsAdmin || 'Not specified'} />
        <RightInfoItem title="Phone" value={right.phone || 'Not specified'} />
        <RightInfoItem title="Email" value={right.email || 'Not specified'} />
      </RightInfoRow>
    </RightInfoCard>
  );
};
